import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IAssessment } from '../models/assessment';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class HazardAnnexesService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

  getALAssessments(buildingId: string, assessmentTypeId: string): Observable<{has_error: boolean, message: string, data: IAssessment[]}> {
    const url = environment.apiBaseUrl + endpoints.getBuildingALAssessments.replace(':buildingId', buildingId).replace(':assessmentTypeId', assessmentTypeId.toString());
    
    return this.http.get<{has_error: boolean, message: string, data: IAssessment[]}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  sendAssessmentRequest(buildingId: string, assessTypeId: string, assessSubTypeId: string, data: {email: string, contact_id?: number}[]): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.sendALAssessmentRequest.replace(':buildingId', buildingId).replace(':assessmentTypeId', assessTypeId).replace(':assessmentSubTypeId', assessSubTypeId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
      catchError(this.errorService.handleError)
    );
  }

  sendClassroomAssessment(buildingId: string, roomNumber: string, data: {email: string, contact_id?: number}[]): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.sendClassroomALAssessmentRequest.replace(':buildingId', buildingId).replace(':roomNumber', roomNumber);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
      catchError(this.errorService.handleError)
    );
  }

  updateALAssessment(buildingId: string, assessTypeId: string, assessSubTypeId: string, payload: any): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.updateALAssessment.replace(':buildingId', buildingId).replace(':assessmentTypeId', assessTypeId).replace(':assessmentSubTypeId', assessSubTypeId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, payload).pipe(
      catchError(this.errorService.handleError)
    );
  }

  createALClassroomAssessment(buildingId: string, payload: any): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.createALClassroomAssessment.replace(':buildingId', buildingId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, payload).pipe(
      catchError(this.errorService.handleError)
    );
  }

  updateALClassroomAssessment(buildingId: string, assessmentId: string, payload: any): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.updateALClassroomAssessment.replace(':buildingId', buildingId).replace(':assessmentId', assessmentId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, payload).pipe(
      catchError(this.errorService.handleError)
    );
  }

  confirmALAssessment(buildingId: string, assessTypeId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.confirmALAssessment.replace(':buildingId', buildingId).replace(':assessmentTypeId', assessTypeId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, {}).pipe(
      catchError(this.errorService.handleError)
    );
  }

  deleteAssess(assessId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.deleteALAssessment.replace(':assessId', assessId);
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  downloadSurvey(guid: string): Observable<Blob> {
    const url = environment.apiBaseUrl + endpoints.downloadSurvey.replace(':guid', guid);
    return this.http.get(url, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorService.handleError(error));
      })
    );
  }
}